export default class TextValueType {
  text: string
  value: string
  ':type': string

  constructor(data: any) {
    this.text = data.text
    this.value = data.value
    this[':type'] = data[':type']
  }
}
